import React from 'react';
import { Outlet } from 'react-router-dom';
import { Section } from '@/components/shared/section/Section';
import { UserService } from '@/api/user';

type GateProps = {
  role?: string[] | string;
};

export const Gate: React.FC<GateProps> = ({ role }) => {
  const { data } = UserService.useGetProfile();
  const roleName = data?.role;
  const isValid = role === undefined ? true : Array.isArray(role) && roleName ? role.includes(roleName) : roleName === role;

  if (!isValid) {
    return (
      <Section title="Forbidden">
        <div className="flex flex-col items-center gap-1 p-10">
          <span className="text-lg font-bold">403 Forbidden</span>
          <p>Anda tidak memiliki akses ke halaman ini</p>
        </div>
      </Section>
    );
  }

  return <Outlet />;
};
